import { IS_PROD } from "../shared/constants";
import { getCookie, setCookie, CookieTypes } from "../shared/cookie";
import PubSub from "pubsub-js";
import md5 from "blueimp-md5";
import { sendCookieDito } from "../vanilla/utils";

export const gaCrossCias = () => {
	if (!IS_PROD) return;

	const script = document.currentScript;

	if (script) {
		setCookie(
			"rtc",
			script.src.includes("static-roundtrip.maxmilhas.com.br"),
			CookieTypes.ANALYTIC
		);
	}

	const isRoundTrip = getCookie("rtc", CookieTypes.ANALYTIC) === "true";

	if (isRoundTrip) {
		PubSub.publish("dataLayer", {
			versionCrossCias: "variant"
		});
	} else {
		PubSub.publish("dataLayer", {
			versionCrossCias: "original"
		});
	}
};

export const acessouLogin = () => {
	PubSub.publish("dataLayer", {
		event: "ditoTrack",
		ditoTrack: {
			action: "acessou-cadastro"
		}
	});
};

export const registerSuccess = (email, flow) => {
	PubSub.publish("dataLayer", {
		event: "ditoIdentifyEmail",
		ditoIdentify: {
			email
		}
	});

	PubSub.publish("dataLayer", {
		event: "gaEvent",
		userId: md5(email),
		gaEventCategory: "Identificação de e-mail",
		gaEventAction: "Cadastro",
		gaEventLabel: flow,
		gaEventValue: ""
	});
	const lastClick = getCookie("last_click", CookieTypes.PUBLICITY);
	const cac = getCookie("cac", CookieTypes.PUBLICITY);
	const lastClickAffiliateDito = sendCookieDito(lastClick, cac);

	PubSub.publish("dataLayer", {
		event: "ditoTrack",
		ditoTrack: {
			action: "cadastro-dados",
			data: lastClickAffiliateDito,
			userId: md5(email),
		}
	});
};
